export default {"src":"/oferta/_next/static/media/fgt-yellow.ec3f7425.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};